import { render, staticRenderFns } from "./FormReviewFormat.vue?vue&type=template&id=7aecd6ec&"
import script from "./FormReviewFormat.vue?vue&type=script&lang=js&"
export * from "./FormReviewFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports